import api from './api';

export const luongService = {
  getAllLuongNhanVien(maKhoa: number) {
    return api.get('/Luong/luong-nhan-vien', { params: { maKhoa } });
  },

  getLuongNhanVien(maChamCong: string) {
    return api.get(`/Luong/luong-nhan-vien/${maChamCong}`);
  },

  updateLuongNhanVien(data: {
    maChamCong: string;
    nguoiPhuThuoc: number;
    luongBHXH: number;
    luongNS: number;
    phuCapTN: number;
    tnKhac: number;
    phuCapXX: number;
  }) {
    return api.put('/Luong/luong-nhan-vien', data);
  },

  getLuongConfig() {
    return api.get('/Luong/luong-config');
  },

  updateLuongConfig(data: {
    giamTruCaNhan: number;
    giamTruNguoiPhuThuoc: number;
    tyLeBHXH: number;
    tyLeBHYT: number;
    tyLeBHTN: number;
  }) {
    return api.put('/Luong/luong-config', data);
  },

  getTienPhuCapTruc() {
    return api.get('/Luong/tien-phu-cap-truc');
  },

  updateTienPhuCapTruc(data: { kyHieu: string; soTien: number }) {
    return api.put('/Luong/tien-phu-cap-truc', data);
  },

  deleteTienPhuCapTruc(kyHieu: string) {
    return api.delete(`/Luong/tien-phu-cap-truc/${kyHieu}`);
  },

  getNgoaiLeTienTruc(maKhoa: number) {
    return api.get('/Luong/ngoai-le-tien-truc', { params: { maKhoa } });
  },

  updateNgoaiLeTienTruc(data: { maChamCong: string; maLoai: string; soTien: number; nguoiCapNhat: string }) {
    return api.put('/Luong/ngoai-le-tien-truc', data);
  },

  deleteNgoaiLeTienTruc(id: number) {
    return api.delete(`/Luong/ngoai-le-tien-truc/${id}`);
  },

  getBangLuong(maKhoa: number, thang: number, nam: number) {
    return api.get('/Luong/bang-luong', {
      params: { maKhoa, thang, nam }
    });
  },

  tinhLuongKhoa(data: {
    maKhoa: number;
    thang: number;
    nam: number;
    nguoiTao: string;
  }) {
    return api.post('/Luong/tinh-luong', data);
  }
};
